import React from 'react';
import { Quote, Star, Award, Users, Shield, Clock } from 'lucide-react';
import { testimonials } from '../mock';

const Testimonials = () => {
  return (
    <section id="testimonials" className="pad-120 bg-gradient-to-b from-black via-gray-950 to-black">
      <div className="container">
        {/* Section Header */}
        <div className="text-center mb-20">
          <div className="inline-block mb-4 px-4 py-2 bg-yellow-500/10 rounded-full">
            <span className="text-yellow-400 text-sm font-semibold uppercase tracking-wider flex items-center gap-2">
              <Star size={16} className="fill-yellow-400" />
              Testimonials
            </span>
          </div>
          <h2 className="heading-1 mb-6 bg-gradient-to-r from-white via-gray-200 to-gray-400 bg-clip-text text-transparent">
            What Our Clients Say
          </h2>
          <p className="body-large text-gray-400 max-w-3xl mx-auto">
            Trusted by vehicle owners across the Lower Mainland for premium mobile detailing
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {testimonials.map((testimonial) => (
            <div 
              key={testimonial.id}
              className="group bg-gradient-to-br from-gray-900/80 to-gray-900/40 backdrop-blur-sm border border-gray-800 hover:border-blue-500/30 rounded-2xl p-6 transition-all duration-300 hover:scale-105"
            >
              {/* Quote Icon */}
              <div className="mb-4">
                <Quote size={32} className="text-blue-400/30" />
              </div>

              {/* Rating */}
              <div className="flex items-center gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} size={16} className="fill-yellow-400 text-yellow-400" />
                ))}
              </div>

              {/* Review Text */}
              <p className="body-medium text-gray-300 mb-6 leading-relaxed italic">
                "{testimonial.text}"
              </p>

              {/* Author Info */}
              <div className="pt-4 border-t border-gray-800">
                <div className="flex items-center justify-between">
                  <div>
                    <div className="font-semibold text-white">{testimonial.name}</div>
                    <div className="text-sm text-gray-500">{testimonial.location}</div>
                  </div>
                  <div className="text-right">
                    <div className="text-xs text-gray-500">{testimonial.source}</div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Stats Section removed — space preserved */}
        <div className="mt-16 h-48 md:h-56" aria-hidden="true"></div>
      </div>
    </section>
  );
};

export default Testimonials;